import React, { useState, useEffect, useRef, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '@components/common/Layout';

import {
  getApplicationRoles,
  getRoleAgents,
  getCommonCodeDtlList,
  updateDetailRoleInfo,
  updateDetailRoleInfoClear,
  updateSearchRoleInfo,
  getRoleExcelDown,
  saveApplicationRole,
  saveRoleAgents,
  findAgentsCdpPagingList,
  upsetAgentTotalCountReset,
} from '@store/actions/roleAction';

import {
  getHqListByChannel,
  getAgencyListByHq,
  getHqAgencyClear,
  showModal,
} from '@store/actions/commonAction';

import RoleMainList from '@components/role/RoleMainList';
import RoleDetail from '@components/role/RoleDetail';
import RoleUpdate from '@components/role/RoleUpdate';
import RoleAgentList from '@components/role/RoleAgentList';
import RoleAgentEditList from '@components/role/RoleAgentEditList';
import AgentsListPopup from '@components/role/AgentsListPopup';
import SatModal from '@components/common/satUI/SatModal';
import { isEmptyString } from '@common/utils/validation';
import { getToday } from '@common/utils/date';

const RoleMain = () => {
  const dispatch = useDispatch();
  const [roleDetailVisible, setRoleDetailVisible] = useState(true);
  const [roleUpdateVisible, setRoleUpdateVisible] = useState(false);
  const [roleAgentListVisible, setRoleAgentListVisible] = useState(true);
  const [roleAgentEditListVisible, setRoleAgentEditListVisible] =
    useState(false);
  const [roleIdTrueFalse, setRoleIdTrueFalse] = useState(false);
  const [selectRoleAgents, setSelectRoleAgents] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [agentsListVisible, setAgentsListVisible] = useState(false);
  const [menuTitle, setTmenuTitle] = useState('권한관리');
  const [roleInsertUpdate, setRoleInsertUpdate] = useState(false);
  const [tempAgentTotalCount, setTempAgentTotalCount] = useState(0);
  const [initial, setInitial] = useState(false);
  const {
    searchRoleInfo,
    roleList,
    totalCount,
    agentRoleList,
    agentTotalCount,
    codeList,
    roleFirstInfo,
    cdpList,
    cdpTotalCount,
  } = useSelector(state => state.roleReducer);
  const { hqList, agencyList } = useSelector(state => state.commonReducer);
  const roleIdRef = useRef();
  const roleNmRef = useRef();
  const nameRef = useRef();
  const [searchCondition, setSearchCondition] = useState({
    roleId: '',
    chnlCd: '',
    hqCd: '',
    agncCd: '',
  });
  const [selectRow, setSelectRow] = useState({
    rowIndex: '',
  });

  useEffect(() => {
    dispatch(updateDetailRoleInfoClear());

    //공통코드 조회
    dispatch(
      getCommonCodeDtlList({
        cdTyId: 'ORG_CHNL_CD',
        useYn: 'Y',
      }),
    );

    //권한목록 조회
    dispatch(
      getApplicationRoles({
        aplctnTpCd: searchRoleInfo.aplctnTpCd,
      }),
    );
  }, []);

  useEffect(() => {
    setRoleIdTrueFalse(false); //권한수정 권한코드 readonly 여부
    setRoleDetailVisible(true); //권한상세
    setRoleUpdateVisible(false); //권한상세 수정 등록
    setRoleAgentListVisible(true); //권한사용자 목록
    setRoleAgentEditListVisible(false); //권한사용자 수정
  }, [roleList]);

  useEffect(() => {
    setSelectRoleAgents(agentRoleList);
    setCheckAll(false);
  }, [agentRoleList]);

  const allCheck3 = checked => {
    if (checked === true) {
      let result = agentRoleList.map(selectFile =>
        Object.assign(selectFile, { isChecked: checked }),
      );
    } else {
      let result = agentRoleList.filter(selectFile =>
        Object.assign(selectFile, { isChecked: checked }),
      );
    }

    setCheckAll(!checkAll);
  };

  const singleCheck30 = (checked, empno) => {
    if (checked === true) {
      const roleAgent = agentRoleList.map(f =>
        f.empno === empno ? Object.assign(f, { isChecked: checked }) : f,
      );
      setSelectRoleAgents(roleAgent);
    } else {
      const index = agentRoleList.findIndex(s => s.empno === empno);

      const checkEmpno = Object.assign(agentRoleList[index], {
        isChecked: checked,
      });

      agentRoleList[index] = checkEmpno;
      setSelectRoleAgents(agentRoleList);

      if (agentRoleList.length > 0) {
        const rest = agentRoleList.map(list =>
          list.empno === empno
            ? Object.assign(list, { isChecked: checked })
            : list,
        );
        setSelectRoleAgents(rest);
      }
    }

    // checked All 점검
    setCheckAll(
      Object.values(agentRoleList).every(
        selectRoleAgents => selectRoleAgents.isChecked === true,
      ),
    );
  };

  const insert = () => {
    dispatch(updateDetailRoleInfoClear());

    //agentTotalCount //초기화
    setTempAgentTotalCount(1);
    dispatch(upsetAgentTotalCountReset());

    setTmenuTitle('권한등록');
    setRoleInsertUpdate(false);
    setRoleIdTrueFalse(false); //권한수정 권한코드 readonly 여부
    setRoleDetailVisible(false); //권한상세
    setRoleUpdateVisible(true); //권한상세 수정 등록
    setRoleAgentListVisible(false); //권한사용자 목록
    setRoleAgentEditListVisible(true); //권한사용자 수정
  };

  const update = () => {
    if (searchCondition.roleId === '') {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '수정할 권한을 선택해주세요.',
        }),
      );
    } else {
      //권한을 가지고 있는 사용자를 재조회(검색조건때문)
      dispatch(
        getRoleAgents({
          roleId:
            searchCondition.roleId === ''
              ? roleFirstInfo.roleId
              : searchCondition.roleId,
        }),
      );

      setTempAgentTotalCount(agentTotalCount);
      setTmenuTitle('권한수정');
      setRoleInsertUpdate(true);
      setRoleIdTrueFalse(true); //권한수정 권한코드 readonly 여부
      setRoleDetailVisible(false); //권한상세
      setRoleUpdateVisible(true); //권한상세 수정 등록
      setRoleAgentListVisible(false); //권한사용자 목록
      setRoleAgentEditListVisible(true); //권한사용자 수정
    }
  };

  const rowSelect = row => {
    setSelectRow({
      rowIndex: row.rowIndex,
    });

    const data = Object.values(roleList).filter(f => f.roleId === row.roleId);

    dispatch(
      updateDetailRoleInfo({
        roleId: data[0].roleId,
        roleNm: data[0].roleNm,
        useYn: data[0].useYn,
        roleCd: data[0].roleCd,
        roleDsc: data[0].roleDsc,
      }),
    );

    dispatch(
      getRoleAgents({
        roleId: data[0].roleId,
      }),
    );

    setSearchCondition({
      ...searchCondition,
      roleId: data[0].roleId,
      chnlCd: '',
      hqCd: '',
      agncCd: '',
    });
  };

  const handleUseYn = type => {
    dispatch(
      updateDetailRoleInfo({
        useYn: type,
      }),
    );
  };

  const handleRoleCd = type => {
    dispatch(
      updateDetailRoleInfo({
        roleCd: type,
      }),
    );
  };

  const handleInputEvent = (value, targetId) => {
    if (targetId === 'roleId') {
      dispatch(
        updateDetailRoleInfo({
          roleId: value,
        }),
      );
    } else if (targetId === 'roleNm') {
      dispatch(
        updateDetailRoleInfo({
          roleNm: value,
        }),
      );
    } else if (targetId === 'roleDsc') {
      dispatch(
        updateDetailRoleInfo({
          roleDsc: value,
        }),
      );
    } else if (targetId === 'agentNm') {
      dispatch(
        updateSearchRoleInfo({
          agentNm: value,
        }),
      );
    }
  };

  const save = () => {
    //선택한 권한정보 수정
    if (roleValidate()) {
      dispatch(saveApplicationRole(roleFirstInfo));

      const list = Object.values(agentRoleList).filter(
        f => f.isChecked === true,
      );
      const insertSel = list.map(f =>
        Object.assign(f, { useYn: 'Y', roleId: roleFirstInfo.roleId }),
      );

      if (insertSel.length > 0) {
        dispatch(saveRoleAgents(insertSel));
      }

      setSelectRow({
        rowIndex: '',
      });

      dispatch(updateDetailRoleInfoClear());
      setInitial(true);

      setTmenuTitle('권한관리');
    }
  };

  const roleValidate = () => {
    if (isEmptyString(roleFirstInfo.roleId)) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '권한코드를 입력하세요.',
          onOk: {
            handle: () => roleIdRef?.current?.onFocus(),
          },
        }),
      );
      return false;
    }

    if (isEmptyString(roleFirstInfo.roleNm)) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '권한명을 입력하세요.',
          onOk: {
            handle: () => roleNmRef?.current?.onFocus(),
          },
        }),
      );
      return false;
    }

    return true;
  };

  const cancel = () => {
    //공통코드 조회
    dispatch(
      getCommonCodeDtlList({
        cdTyId: 'ORG_CHNL_CD',
        useYn: 'Y',
      }),
    );

    //권한목록 조회
    dispatch(
      getApplicationRoles({
        aplctnTpCd: searchRoleInfo.aplctnTpCd,
      }),
    );

    setSearchCondition({
      roleId: '',
      chnlCd: '',
      hqCd: '',
      agncCd: '',
    });

    setSelectRow({
      rowIndex: '',
    });

    setTmenuTitle('권한관리');
    setRoleIdTrueFalse(false); //권한수정 권한코드 readonly 여부
    setRoleDetailVisible(true); //권한상세
    setRoleUpdateVisible(false); //권한상세 수정 등록
    setRoleAgentListVisible(true); //권한사용자 목록
    setRoleAgentEditListVisible(false); //권한사용자 수정
    setInitial(true);

    dispatch(updateDetailRoleInfoClear());
  };

  const del = () => {
    const list = Object.values(agentRoleList).filter(f => f.isChecked === true);

    if (list.length > 0) {
      //체크박스 선택여부 확인

      dispatch(
        showModal({
          visible: true,
          type: 'confirm',
          msg: '선택한 사용자에게 해당권한을 삭제 하시겠습니까?',
          onOk: {
            label: '예',
            handle: () => {
              const delSel = list.map(f => Object.assign(f, { useYn: 'N' }));
              setSelectRoleAgents(delSel);
              dispatch(saveRoleAgents(delSel));
            },
          },
          onCancel: { label: '아니요' },
        }),
      );
    }
  };

  const agentsSearchPopup = () => {
    setAgentsListVisible(true);

    //사용자목록 조회
    dispatch(findAgentsCdpPagingList(searchCondition));
  };

  const pageChange = value => {
    //권한목록 조회
    dispatch(
      getApplicationRoles({
        aplctnTpCd: searchRoleInfo.aplctnTpCd,
        targetRow: value * 10 + 1,
      }),
    );

    setSelectRow({
      rowIndex: '',
    });

    dispatch(updateDetailRoleInfoClear());
  };

  //권한엑셀다운로드
  const excelDown = () => {
    const today = getToday('yyyyMMddHHmm');

    if (searchCondition.roleId === '') {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '다운로드할 데이터가 없습니다.',
        }),
      );
    } else {
      dispatch(
        getRoleExcelDown({
          roleId: searchCondition.roleId,
          excelFileName: '권한관리_' + today + '.xlsx',
        }),
      );
    }
  };

  const handleChangeChnlSelect = e => {
    if (e.target.id === 'selectChnlId') {
      setSearchCondition({
        ...searchCondition,
        chnlCd: e.target.value,
        hqCd: '',
        agncCd: '',
      });

      dispatch(
        getHqListByChannel({
          chnlCd: e.target.value,
        }),
      );

      if (searchCondition.roleId != '' || roleFirstInfo.roleId != '') {
        dispatch(
          getRoleAgents({
            roleId:
              searchCondition.roleId === ''
                ? roleFirstInfo.roleId
                : searchCondition.roleId,
            chnlCd: e.target.value,
          }),
        );
      }

      dispatch(getHqAgencyClear());
    } else if (e.target.id === 'selectHqId') {
      setSearchCondition({
        ...searchCondition,
        hqCd: e.target.value,
      });

      dispatch(
        getAgencyListByHq({
          chnlCd: searchCondition.chnlCd,
          hqCd: e.target.value,
        }),
      );

      dispatch(
        getRoleAgents({
          roleId:
            searchCondition.roleId === ''
              ? roleFirstInfo.roleId
              : searchCondition.roleId,
          chnlCd: searchCondition.chnlCd,
          hqCd: e.target.value,
        }),
      );
    } else if (e.target.id === 'selectAgncId') {
      setSearchCondition({
        ...searchCondition,
        agncCd: e.target.value,
      });

      dispatch(
        getRoleAgents({
          roleId:
            searchCondition.roleId === ''
              ? roleFirstInfo.roleId
              : searchCondition.roleId,
          chnlCd: searchCondition.chnlCd,
          hqCd: searchCondition.hqCd,
          agncCd: e.target.value,
        }),
      );
    }
  };

  const pageAgentChange = value => {
    if (agentTotalCount > 10) {
      //권한목록 조회
      dispatch(
        getRoleAgents({
          roleId:
            searchCondition.roleId === ''
              ? roleFirstInfo.roleId
              : searchCondition.roleId,
          chnlCd: searchCondition.chnlCd,
          hqCd: searchCondition.hqCd,
          agncCd: searchCondition.agncCd,
          targetRow: value * 10 + 1,
        }),
      );
    }
  };

  return (
    <React.Fragment>
      <Layout>
        <div className="content manage-content">
          <div className="con-wrap">
            <div className="app-wrap">
              <div className="app-box">
                <div className="con-bottom">
                  <div className="tit-area">
                    <h2 className="tit-con">{menuTitle}</h2>
                  </div>
                  <div className="text-info">
                    <span className="ico ico-info-yellow"></span>
                    다중채널접근권한 : 채널별 화면 확인을 위한 권한으로,
                    권한관리와 사용자별권한관리에서만 확인이 가능합니다.(권한별
                    메뉴관리에서는 불필요)
                  </div>
                  <div className="col-tbl-wrap mgt-0">
                    <RoleMainList
                      list={roleList}
                      totalCount={totalCount}
                      rowSelect={rowSelect}
                      selectRow={selectRow}
                      pageChange={pageChange}
                      initial={initial}
                    />
                    <div className="table-wrap-reg">
                      <div className="no-round-box">
                        <div className="tit-area">
                          <h3>선택한 권한정보</h3>
                        </div>
                        <RoleDetail
                          roleFirstInfo={roleFirstInfo}
                          visible={roleDetailVisible}
                          handleInputEvent={handleInputEvent}
                          handleUseYn={handleUseYn}
                          handleRoleCd={handleRoleCd}
                        />
                        <RoleUpdate
                          roleFirstInfo={roleFirstInfo}
                          visible={roleUpdateVisible}
                          roleNmRef={roleNmRef}
                          roleIdRef={roleIdRef}
                          handleInputEvent={handleInputEvent}
                          handleUseYn={handleUseYn}
                          handleRoleCd={handleRoleCd}
                          roleIdTrueFalse={roleIdTrueFalse}
                          roleInsertUpdate={roleInsertUpdate}
                        />
                        <RoleAgentList
                          visible={roleAgentListVisible}
                          codeList={codeList}
                          agentRoleList={agentRoleList}
                          agentTotalCount={agentTotalCount}
                          handleChangeChnlSelect={handleChangeChnlSelect}
                          hqList={hqList}
                          agencyList={agencyList}
                          searchCondition={searchCondition}
                          pageAgentChange={pageAgentChange}
                          initial={initial}
                        />
                        <RoleAgentEditList
                          visible={roleAgentEditListVisible}
                          agentRoleList={agentRoleList}
                          agentsSearchPopup={agentsSearchPopup}
                          checkAll={checkAll}
                          singleCheck30={singleCheck30}
                          allCheck={allCheck3}
                          del={del}
                          agentTotalCount={agentTotalCount}
                          tempAgentTotalCount={tempAgentTotalCount}
                          pageAgentChange={pageAgentChange}
                          initial={initial}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {!roleAgentEditListVisible ? (
                  <div className="btn-area-jb no-flex">
                    <div className="flex">
                      <div className="btn-area-l">
                        <button
                          className="memo-reg"
                          onClick={() => excelDown()}
                        >
                          <span className="ico ico-exl-down"></span>
                          엑셀 다운로드
                        </button>
                      </div>
                      <ul className="file-list">
                        <li>
                          <button
                            className="btn-m add"
                            onClick={() => insert()}
                          >
                            추가
                          </button>
                        </li>
                        <li>
                          <button
                            className="btn-m modify"
                            onClick={() => update()}
                          >
                            수정
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  <div className="btn-area-jb">
                    <ul className="file-list">
                      <li>
                        <button
                          className="btn-m cancel"
                          onClick={() => cancel()}
                        >
                          취소
                        </button>
                      </li>
                      <li>
                        <button className="btn-m save" onClick={() => save()}>
                          저장
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <SatModal
          visible={agentsListVisible}
          setVisible={() => setAgentsListVisible(false)}
          type="newInfo2"
          onCloseButton
        >
          <AgentsListPopup
            title={'권한등록할 사용자 검색'}
            nameRef={nameRef}
            cdpList={cdpList}
            codeList={codeList}
            cdpTotalCount={cdpTotalCount}
            handleInputEvent={handleInputEvent}
            handleClose={() => setAgentsListVisible(false)}
          />
        </SatModal>
      </Layout>
    </React.Fragment>
  );
};

export default memo(RoleMain);
